(() => {
  const config = document.getElementById('AlphaLanguageLabels');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const apply = root => {
    const language = root.querySelector('select[name="locale_code"]');
    const currency = root.querySelector('select[name="translation_shop_currency"]');
    if (!language || !language.options.length) return false;
    if (language.getAttribute('aria-label') !== labels.language) language.setAttribute('aria-label', labels.language);
    if (currency && currency.getAttribute('aria-label') !== labels.currency) currency.setAttribute('aria-label', labels.currency);
    for (const option of language.options) {
      const name = labels.names[option.value];
      if (!name) continue;
      const flag = option.textContent.trim().match(/^([\u{1F1E6}-\u{1F1FF}]{2})/u)?.[1];
      const text = (flag ? flag + ' ' : '') + name;
      if (option.textContent.trim() !== text) option.textContent = text;
    }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement?.closest('select,script,style')) continue;
      const text = node.nodeValue.trim();
      if (text === 'Language' && labels.language !== text) node.nodeValue = node.nodeValue.replace(text, labels.language);
      if (text === 'Currency' && labels.currency !== text) node.nodeValue = node.nodeValue.replace(text, labels.currency);
    }
    return true;
  };
  const attach = () => {
    const roots = document.querySelectorAll('[id^="TranslationShopEmbed"]');
    let found = false;
    for (const root of roots) {
      if (!apply(root)) continue;
      found = true;
      if (!root.dataset.alphaLanguageNames) {
        root.dataset.alphaLanguageNames = 'true';
        new MutationObserver(() => apply(root)).observe(root, {childList: true, subtree: true});
      }
    }
    return found;
  };
  const start = () => {
    if (attach()) return;
    const observer = new MutationObserver(() => { if (attach()) observer.disconnect(); });
    observer.observe(document.getElementById('header-group') || document.body, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
